export default __webpack_public_path__ + "static/media/DMFullColourSA.ad4e10a4.svg";